<template>
  <button @click="onclick" class="c-btn">
    <slot>Button</slot>
  </button>
</template>
<script>
export default {
  name: "Button",

  props: {
    onclick: {type: Function, required: true},
    disable: {type: Boolean, required: false, default: false}
  }
}
</script>
